<template>
  <svg
    :width="width"
    :height="height"
    viewBox="0 0 22 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path d="M10 4.5L10 17.5" :stroke="iconStroke" stroke-width="1.5" stroke-linecap="round" />
    <path
      d="M10 17.5C9.7777 17.5 9.32354 17.2579 8.41526 16.7738C7.4921 16.2818 6.2167 15.7922 4.5825 15.4849C2.74929 15.1401 1.83268 14.9678 1.41634 14.4588C1 13.9499 1 13.1347 1 11.5044V5.09655C1 3.31353 1 2.42202 1.6487 1.87302C2.29741 1.32401 3.05911 1.46725 4.5825 1.75372C7.58958 2.3192 9.3818 3.50205 10 4.18114C10.6182 3.50205 12.4104 2.3192 15.4175 1.75372C16.9409 1.46725 17.7026 1.32401 18.3513 1.87302C19 2.42202 19 3.31353 19 5.09655V8"
      :stroke="iconStroke"
      stroke-width="1.5"
      stroke-linecap="round"
      stroke-linejoin="round"
    />
    <path
      d="M14.3477 18.3557L14.1909 17.6223L14.3477 18.3557ZM13.1443 17.1523L13.8777 17.3091L13.1443 17.1523ZM14.0207 14.6117L13.4903 14.0814H13.4903L14.0207 14.6117ZM20.7963 11.9773L21.4458 11.6023L20.7963 11.9773ZM20.7963 13.4981L21.4458 13.8731L20.7963 13.4981ZM19.5227 10.7037L19.8977 10.0542L19.5227 10.7037ZM17.3285 11.3039L17.8588 11.8342L17.3285 11.3039ZM18.0019 10.7037L17.6269 10.0542L17.6269 10.0542L18.0019 10.7037ZM19.6658 13.6412L16.358 16.949L17.4186 18.0097L20.7265 14.7018L19.6658 13.6412ZM14.551 15.142L17.8588 11.8342L16.7982 10.7735L13.4903 14.0814L14.551 15.142ZM14.1909 17.6223C14.0155 17.6598 13.8753 17.6897 13.7548 17.7121C13.6333 17.7347 13.5536 17.7454 13.4996 17.7488C13.4441 17.7524 13.4479 17.7458 13.4825 17.7547C13.5296 17.7669 13.5936 17.7972 13.6482 17.8518L12.5876 18.9124C12.9113 19.2362 13.3158 19.2636 13.5948 19.2458C13.8603 19.2289 14.1839 19.1577 14.5045 19.0891L14.1909 17.6223ZM12.4109 16.9955C12.3423 17.3161 12.2711 17.6397 12.2542 17.9052C12.2364 18.1842 12.2638 18.5887 12.5876 18.9124L13.6482 17.8518C13.7028 17.9064 13.7331 17.9704 13.7453 18.0175C13.7542 18.0521 13.7476 18.0559 13.7512 18.0004C13.7546 17.9464 13.7653 17.8667 13.7879 17.7452C13.8103 17.6247 13.8402 17.4845 13.8777 17.3091L12.4109 16.9955ZM19.6658 11.8342C20.0333 12.2017 20.1084 12.286 20.1467 12.3523L21.4458 11.6023C21.2839 11.3218 21.0257 11.0728 20.7265 10.7735L19.6658 11.8342ZM20.7265 14.7018C21.0257 14.4026 21.2839 14.1535 21.4458 13.8731L20.1467 13.1231C20.1084 13.1894 20.0333 13.2737 19.6658 13.6412L20.7265 14.7018ZM20.1467 12.3523C20.2844 12.5908 20.2844 12.8846 20.1467 13.1231L21.4458 13.8731C21.8514 13.1705 21.8514 12.3049 21.4458 11.6023L20.1467 12.3523ZM20.7265 10.7735C20.4272 10.4743 20.1782 10.2161 19.8977 10.0542L19.1477 11.3533C19.214 11.3916 19.2983 11.4667 19.6658 11.8342L20.7265 10.7735ZM17.8588 11.8342C18.2263 11.4667 18.3106 11.3916 18.3769 11.3533L17.6269 10.0542C17.3465 10.2161 17.0974 10.4743 16.7982 10.7735L17.8588 11.8342ZM19.8977 10.0542C19.1951 9.64859 18.3295 9.64859 17.6269 10.0542L18.3769 11.3533C18.6154 11.2156 18.9092 11.2156 19.1477 11.3533L19.8977 10.0542ZM16.358 16.949C16.1624 17.1445 15.8952 17.271 15.5155 17.3679C15.3253 17.4165 15.1224 17.454 14.8963 17.4931C14.679 17.5306 14.4303 17.5711 14.1909 17.6223L14.5045 19.0891C14.7063 19.046 14.9131 19.0124 15.1517 18.9712C15.3814 18.9315 15.6346 18.8856 15.8866 18.8213C16.3914 18.6924 16.9533 18.475 17.4186 18.0097L16.358 16.949ZM13.8777 17.3091C13.9289 17.0697 13.9694 16.821 14.0069 16.6037C14.046 16.3776 14.0835 16.1747 14.1321 15.9845C14.229 15.6048 14.3555 15.3376 14.551 15.142L13.4903 14.0814C13.025 14.5467 12.8076 15.1086 12.6787 15.6134C12.6144 15.8654 12.5685 16.1186 12.5288 16.3483C12.4876 16.5869 12.454 16.7937 12.4109 16.9955L13.8777 17.3091Z"
      :fill="iconStroke"
    />
  </svg>
</template>

<script>
export default {
  props: {
    height: {
      type: String,
      default: '20',
    },
    width: {
      type: String,
      default: '22',
    },
    color: {
      type: String,
      default: 'primary-purple-600',
    },
  },
  computed: {
    /**
     * Icon Style
     * @param {void}
     * @returns {string} - Color
     * @description Assigns the specific color to the icon
     */
    iconStroke() {
      return `var(--${this.color})`
    },
  },
}
</script>
